import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { BankIcon } from 'foundations-assets/icons/components/BankIcon';
import { CreditCardIcon } from 'foundations-assets/icons/components/CreditCardIcon';
import { CardBody, CardShell, HubSpotHeaderTitle, PaymentMethodsGrid, SectionDivider } from '../NewPublicPaymentOptionsSectionStyles';
import { CheckItem, FeeRow, PaymentMethodBadge, TransactionFeesSectionHeader } from './shared';
import { AFFIRM_ICON_URL, APPLE_PAY_ICON_URL, GOOGLE_PAY_ICON_URL, KLARNA_ICON_URL, STRIPE_ICON_URL } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StripeCardHeader = () => /*#__PURE__*/_jsxs(Flex, {
  alignItems: "center",
  gap: "200",
  children: [/*#__PURE__*/_jsx("img", {
    src: STRIPE_ICON_URL,
    alt: "",
    height: 20,
    style: {
      display: 'block'
    }
  }), /*#__PURE__*/_jsx(HubSpotHeaderTitle, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.stripe.name"
    })
  })]
});
export const StripeCardCTA = ({
  onConnectClick
}) => /*#__PURE__*/_jsx(Button, {
  use: "tertiary",
  block: true,
  onClick: onConnectClick,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "payment-options-new.stripe.connectButton"
  })
});
export const StripeValueProps = () => /*#__PURE__*/_jsxs(Flex, {
  flexDirection: "column",
  gap: "200",
  marginBlockStart: "100",
  children: [/*#__PURE__*/_jsx(CheckItem, {
    iconColor: "icon-core-subtle",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.stripe.valueProps.1"
    })
  }), /*#__PURE__*/_jsx(CheckItem, {
    iconColor: "icon-core-subtle",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.stripe.valueProps.2"
    })
  })]
});
export const StripeTransactionFees = ({
  countryCode
}) => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx(TransactionFeesSectionHeader, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.stripe.transactionFees.title"
    })
  }), /*#__PURE__*/_jsx(FeeRow, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.stripe.transactionFees.platformFee.label"
    }),
    value: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.stripe.transactionFees.platformFee.value"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.stripe.transactionFees.platformFee.description"
    })
  }), /*#__PURE__*/_jsx(FeeRow, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.stripe.transactionFees.creditDebit.label"
    }),
    value: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.stripe.transactionFees.creditDebit.value"
    }),
    description: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "payment-options-new.stripe.transactionFees.creditDebit.description_jsx",
      elements: {
        Bold: 'strong'
      }
    })
  }), /*#__PURE__*/_jsx(FeeRow, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.stripe.transactionFees.ach.label"
    }),
    value: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.stripe.transactionFees.ach.value"
    }),
    description: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "payment-options-new.stripe.transactionFees.ach.description_jsx",
      elements: {
        Bold: 'strong'
      }
    })
  }), countryCode !== 'GB' && /*#__PURE__*/_jsx(FeeRow, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.stripe.transactionFees.bnpl.label"
    }),
    value: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.stripe.transactionFees.bnpl.value"
    }),
    description: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "payment-options-new.stripe.transactionFees.bnpl.description_jsx",
      elements: {
        Bold: 'strong'
      }
    })
  })]
});
export const StripeAdditionalFees = () => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx(Text, {
    as: "strong",
    typography: "heading-200",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.stripe.additionalFees.title"
    })
  }), /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "200",
    marginBlockStart: "200",
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "payment-options-new.stripe.additionalFees.fraud_jsx",
        elements: {
          Bold: 'strong'
        }
      })
    }), /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "payment-options-new.stripe.additionalFees.cardUpdated_jsx",
        elements: {
          Bold: 'strong'
        }
      })
    }), /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "payment-options-new.stripe.additionalFees.bankLinked_jsx",
        elements: {
          Bold: 'strong'
        }
      })
    })]
  })]
});
export const StripePaymentMethodsSection = () => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx(Text, {
    as: "strong",
    typography: "heading-100",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.stripe.paymentMethods.title"
    })
  }), /*#__PURE__*/_jsxs(PaymentMethodsGrid, {
    children: [/*#__PURE__*/_jsx(PaymentMethodBadge, {
      icon: /*#__PURE__*/_jsx(CreditCardIcon, {}),
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payment-options-new.stripe.paymentMethods.creditDebit"
      })
    }), /*#__PURE__*/_jsx(PaymentMethodBadge, {
      icon: /*#__PURE__*/_jsx("img", {
        src: APPLE_PAY_ICON_URL,
        alt: "",
        height: 12,
        style: {
          display: 'block'
        }
      }),
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payment-options-new.stripe.paymentMethods.applePay"
      })
    }), /*#__PURE__*/_jsx(PaymentMethodBadge, {
      icon: /*#__PURE__*/_jsx("img", {
        src: GOOGLE_PAY_ICON_URL,
        alt: "",
        height: 12,
        style: {
          display: 'block'
        }
      }),
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payment-options-new.stripe.paymentMethods.googlePay"
      })
    }), /*#__PURE__*/_jsx(PaymentMethodBadge, {
      icon: /*#__PURE__*/_jsx("img", {
        src: KLARNA_ICON_URL,
        alt: "",
        height: 12,
        style: {
          display: 'block'
        }
      }),
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payment-options-new.stripe.paymentMethods.klarna"
      })
    }), /*#__PURE__*/_jsx(PaymentMethodBadge, {
      icon: /*#__PURE__*/_jsx("img", {
        src: AFFIRM_ICON_URL,
        alt: "",
        height: 12,
        style: {
          display: 'block'
        }
      }),
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payment-options-new.stripe.paymentMethods.affirm"
      })
    }), /*#__PURE__*/_jsx(PaymentMethodBadge, {
      icon: /*#__PURE__*/_jsx(BankIcon, {}),
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payment-options-new.stripe.paymentMethods.ach"
      })
    }), /*#__PURE__*/_jsx(PaymentMethodBadge, {
      icon: /*#__PURE__*/_jsx(BankIcon, {}),
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payment-options-new.stripe.paymentMethods.pads"
      })
    }), /*#__PURE__*/_jsx(PaymentMethodBadge, {
      icon: /*#__PURE__*/_jsx(BankIcon, {}),
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payment-options-new.stripe.paymentMethods.sepa"
      })
    }), /*#__PURE__*/_jsx(PaymentMethodBadge, {
      icon: /*#__PURE__*/_jsx(BankIcon, {}),
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payment-options-new.stripe.paymentMethods.bacs"
      })
    })]
  })]
});
export const StripeCardFooter = () => /*#__PURE__*/_jsxs(Flex, {
  flexDirection: "column",
  gap: "300",
  children: [/*#__PURE__*/_jsx(Text, {
    typography: "body-100",
    color: "text-secondary-default",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.stripe.availability"
    })
  }), /*#__PURE__*/_jsx(Text, {
    typography: "body-100",
    color: "text-secondary-default",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.stripe.footer.ratesText"
    })
  })]
});
export const StripePaymentCard = ({
  onConnectClick,
  countryCode
}) => /*#__PURE__*/_jsx(CardShell, {
  children: /*#__PURE__*/_jsxs(CardBody, {
    children: [/*#__PURE__*/_jsx(StripeCardHeader, {}), /*#__PURE__*/_jsx(StripeValueProps, {}), /*#__PURE__*/_jsx(StripeCardCTA, {
      onConnectClick: onConnectClick
    }), /*#__PURE__*/_jsx(SectionDivider, {}), /*#__PURE__*/_jsx(StripeTransactionFees, {
      countryCode: countryCode
    }), countryCode !== 'GB' && countryCode !== 'CA' && /*#__PURE__*/_jsx(StripeAdditionalFees, {}), /*#__PURE__*/_jsx(SectionDivider, {}), /*#__PURE__*/_jsx(StripePaymentMethodsSection, {}), /*#__PURE__*/_jsx(SectionDivider, {}), /*#__PURE__*/_jsx(StripeCardFooter, {})]
  })
});